<template>
  <div
    class="w-80 p-3 rounded-lg shadow-xl flex gap-2 justify-between items-start"
    :class="notificationColorClasses"
  >
    <div class="p-1">{{ notification.text }}</div>
    <button
      class="p-2 transition-colors rounded-md cursor-pointer bg-transparent"
      :class="iconColorClasses"
      aria-label="Close"
      @click="notificationStore.removeNotification(notification.id)"
    >
      <Xmark class="w-3.5" />
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";
import Xmark from "@/components/icons/Xmark.vue";
import useNotificationStore from "@/stores/notifications";

const notificationStore = useNotificationStore();

const props = defineProps({
  notification: { type: Object, required: true },
});

const notificationColorClasses = computed(() => {
  switch (props.notification.color) {
    case "green":
      return "bg-green-200 text-green-900";
    case "red":
      return "bg-red-200 text-red-900";
    case "blue":
      return "bg-blue-200 text-blue-900";
  }
  return "bg-gray-200 text-gray-900";
});

const iconColorClasses = computed(() => {
  switch (props.notification.color) {
    case "green":
      return "hover:bg-green-300 text-green-900";
    case "red":
      return "hover:bg-red-300 text-red-900";
    case "blue":
      return "hover:bg-blue-300 text-blue-900";
  }
  return "hover:bg-gray-300 text-gray-700";
});
</script>
